import React from 'react';
import { Button } from 'antd';

interface IMenuDetailsFooterProps {
  isStoreOffline: boolean;
  hasOpenClose: boolean;
  storeOpenTime: string;
  isLoggedIn: boolean;
  orderItemSum: number;
  onAuth: () => void;
  onAddToCart: () => void;
}

export const MenuDetailsFooter: React.FC<IMenuDetailsFooterProps> = React.memo(
  ({ isStoreOffline, hasOpenClose, storeOpenTime, isLoggedIn, orderItemSum, onAuth, onAddToCart }) => {
    if (isStoreOffline) {
      return (
        <div className="t-align-c fs-xss">
          <span className="font-weight-7">Store is offline</span>
          {hasOpenClose && ` — Opens at ${storeOpenTime}`}
        </div>
      );
    }

    if (!isLoggedIn) {
      return (
        <Button size="large" block className="btn" type="primary" onClick={onAuth}>
          Register / log in
        </Button>
      );
    }

    return (
      <Button size="large" block className="btn" type="primary" onClick={onAddToCart}>
        Add to bag
        <span className="pl-2 font-weight-default"> + P{orderItemSum || 0}</span>
      </Button>
    );
  }
);
